import React from 'react';
import { Headers } from '@tw/tw-component-library';
import styled from 'styled-components';
import { COLORS } from '../Activities/ActivityMenu/styles/constants';

const FilterSection = styled.div`
  margin-bottom: 16px;
`;

const FilterLabel = styled(Headers)`
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text?.secondary || '#666'};
`;

const PillBar = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const Pill = styled.button<{ $active: boolean }>`
  padding: 6px 16px;
  border-radius: 16px;
  border: 1px solid ${COLORS.BORDER_LIGHT};
  background: ${({ $active }) =>
    $active ? COLORS.PRIMARY : COLORS.BACKGROUND};
  color: ${({ $active }) =>
    $active ? COLORS.BACKGROUND_PRIMARY : COLORS.TEXT_PRIMARY};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.875rem;

  &:hover {
    background: ${COLORS.PRIMARY};
    color: ${COLORS.BACKGROUND_PRIMARY};
  }
`;

export interface FilterOption {
  id: string;
  label: string;
}

export interface FilterPillsProps {
  label?: string;
  options: FilterOption[];
  currentFilter: string;
  onFilterChange: (filter: string) => void;
  showLabel?: boolean;
}

/**
 * Reusable FilterPills component for consistent filter UI across the app
 */
export const FilterPills: React.FC<FilterPillsProps> = ({
  label,
  options,
  currentFilter,
  onFilterChange,
  showLabel = true,
}) => {
  return (
    <FilterSection>
      {showLabel && label && (
        <FilterLabel headerType="caption">{label}</FilterLabel>
      )}
      <PillBar>
        {options.map((option) => (
          <Pill
            key={option.id}
            $active={currentFilter === option.id}
            onClick={() => onFilterChange(option.id)}
          >
            {option.label}
          </Pill>
        ))}
      </PillBar>
    </FilterSection>
  );
};
